import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import SignUpModal from './SignUpModal';
//import SignUpModal from './SignUpModal';

function SignUp(props) {
    const [showModal, setShowModal] = useState(false);

    return (
        <div className='container pt-5 pb-5'>
            <div className="bg-warning bg-opacity-10 rounded shadow p-5 text-center">
                <Mail className="text-warning mb-3 mx-auto" size={48} />
                <h3 className='display-6 fw-bold text-dark mb-3'>Stay Connected</h3>
                <p className="lead text-muted mb-4">
                    Join our mailing list to receive news, updates, and special offers.
                </p>
                
                <button 
                    onClick={() => setShowModal(true)}
                    className="btn btn-warning btn-lg text-dark px-5 py-3 fw-semibold mb-3"
                >
                    Join Our Mailing List
                </button>
                
                <div className="mt-3">
                    <p className="text-muted mb-2">Want to track your appointments, free session opportunities and earn rewards?</p>
                    <a 
                        href="https://dashboard.mobilebodytherapy.com" 
                        target="_blank"
                        className="text-decoration-none fw-semibold text-dark"
                    >
                        Create an account →
                    </a>
                </div>
            </div>

            {/* Sign Up Modal */}
             <SignUpModal
                isOpen={showModal} 
                onClose={() => setShowModal(false)} 
            />
        </div>
    );
}

export default SignUp;